const zh: Record<string, string> = {
  // 通用
  'app.name': '它界.pet',
  'app.tagline': '让科技守护每一只毛孩子',
  'nav.home': '首页',
  'nav.community': '社区',
  'nav.rescue': '公益',
  'nav.products': '产品',
  'nav.about': '关于',
  'nav.myPets': '我的宠物',
  'nav.admin': '管理后台',
  'nav.login': '登录',
  'nav.logout': '退出',

  // 认证
  'auth.login': '登录',
  'auth.register': '注册',
  'auth.loginTitle': '欢迎回来',
  'auth.loginSubtitle': '登录你的它界账号，查看宠物档案',
  'auth.registerTitle': '创建账号',
  'auth.registerSubtitle': '加入它界，为你的毛孩子建立数字档案',
  'auth.email': '邮箱',
  'auth.password': '密码',
  'auth.passwordPlaceholder': '至少 6 位',
  'auth.confirmPassword': '确认密码',
  'auth.confirmPasswordPlaceholder': '再次输入密码',
  'auth.nickname': '昵称',
  'auth.nicknamePlaceholder': '怎么称呼你？（选填）',
  'auth.loggingIn': '登录中...',
  'auth.registering': '注册中...',
  'auth.noAccount': '还没有账号？',
  'auth.hasAccount': '已有账号？',
  'auth.goRegister': '立即注册',
  'auth.goLogin': '立即登录',
  'auth.loginFailed': '登录失败',
  'auth.registerFailed': '注册失败',

  // 表单验证
  'validation.emailRequired': '请输入邮箱地址',
  'validation.emailInvalid': '邮箱格式不正确',
  'validation.passwordRequired': '请输入密码',
  'validation.passwordMin': '密码至少 6 位',
  'validation.passwordMax': '密码不超过 64 位',
  'validation.confirmPasswordRequired': '请确认密码',
  'validation.passwordMismatch': '两次输入的密码不一致',
  'validation.nicknameMax': '昵称不超过 20 个字符',

  // 宠物
  'pets.myPets': '我的宠物',
  'pets.manage': '管理你名下的宠物信息',
  'pets.add': '添加宠物',
  'pets.edit': '编辑',
  'pets.delete': '删除',
  'pets.confirmDelete': '确定删除 {{name}} 吗？',
  'pets.deleteFailed': '删除失败',
  'pets.loading': '正在加载宠物档案...',
  'pets.empty': '还没有宠物档案，点击右上角添加第一只！',

  // 社区
  'community.title': '社区动态',
  'community.publish': '发布动态',
  'community.loading': '加载中...',
  'community.empty': '暂无动态',
  'community.like': '点赞',
  'community.comment': '评论',

  // 公益
  'rescue.title': '公益救助',

  // 通用操作
  'action.save': '保存',
  'action.cancel': '取消',
  'action.confirm': '确认',
  'action.back': '返回',
  'action.loadMore': '加载更多',
  'action.retry': '重试',
  'action.close': '关闭',

  // 错误
  'error.generic': '发生了意外错误，请刷新页面重试。',
  'error.network': '网络错误，请检查你的连接。',
  'error.notFound': '页面不存在',
  'error.unauthorized': '请先登录',
  'error.forbidden': '无访问权限',
};

export default zh;
